import { h } from 'preact';
import styles from './TextCheckboxList.module.scss';
export function TextCheckboxList({ options, onChange, layout, columns = 1 }) {
    const baseClass = layout === 'filterTop' ? styles.textCheckboxList : styles.textCheckboxListSide;
    const className = columns === 2 ? `${baseClass} ${styles.twoColumns}` : baseClass;
    return (h("div", { class: className }, options.map(option => (h("label", { key: option.id, class: "checkbox-label" },
        h("input", { type: "checkbox", checked: option.selected, onChange: () => onChange(option.id) }),
        h("span", { class: styles.checkboxText }, option.label),
        h("span", { class: styles.count },
            "[",
            option.count,
            "]"))))));
}
